type RadarStatType = {
  issue_title: string
  new_nums: number
}

const RadarStatPill = ({
  title,
  num,
  selected = false,
  onClick,
}: {
  title: string
  num: number
  selected: boolean
  onClick: (title: string) => void
}) => {
  return (
    <span
      className="flex items-center rounded-full text-black align-middle bg-amber-300 px-3 py-1 mx-px cursor-pointer"
      onClick={() => onClick(title)}
    >
      {title}&nbsp;<span className="text-white font-bold bg-amber-600 p-1 rounded-full">{num}</span>
    </span>
  )
}

const RadarFilterBar = ({
  issues,
  onSelect,
}: {
  issues: RadarStatType[]
  onSelect: (title: string) => void
}) => {
  return (
    <div className="block flex mb-2">
      {issues.map((item) => (
        <RadarStatPill
          title={item.issue_title}
          num={item.new_nums}
          selected={false}
          onClick={(title) => onSelect(title)}
        />
      ))}
    </div>
  )
}

export { RadarFilterBar, RadarStatType }
